import { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./DailyAttendanceReportUIHelpers";

const DailyAttendanceReportUIContext = createContext();

export function useDailyAttendanceReportUIContext() {
  return useContext(DailyAttendanceReportUIContext);
}

export const DailyAttendanceReportUIConsumer = DailyAttendanceReportUIContext.Consumer;

export function DailyAttendanceReportUIProvider({ children }) {
  const { user } = useSelector(state => state.auth);
  initialFilter.term = user.currentActiveTerm; // Mevcut Aktif Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams
  };

  return (
    <DailyAttendanceReportUIContext.Provider value={value}>
      {children}
    </DailyAttendanceReportUIContext.Provider>
  );
}